<template>
    <table class="f-topic-main-content-ext" rules="all">
        <tr>
            <!-- issue详情页展示issueId -->
            <th v-if="topicInfo.topicType === 3"
                class="f-topic-main-content-ext-name">
                issue号
            </th>

            <th v-for="item in topicInfo.extBeanList"
                :key="item.name"
                class="f-topic-main-content-ext-name">
                {{item.name}}
            </th>
        </tr>
        <tr>
            <td v-if="topicInfo.topicType === 3"
                class="f-topic-main-content-ext-val">
                #{{topicInfo.issueId}}
            </td>
            
            <!-- 超长文本截断 -->
            <td v-for="item in topicInfo.extBeanList"
                :key="item.name"
                :class="{'f-topic-main-content-ext-val': true, 'f-topic-main-content-ext-val-hover': hasOutLen(item.value)}">
                {{item.value.substr(0, extMaxStrLen)}}
                <!-- 超长展示省略号 -->
                <span v-if="hasOutLen(item.value)">...</span>
                <!-- 超长展示复制按钮，可复制内容到剪贴板 -->
                <span v-if="hasOutLen(item.value)"
                    class="f-topic-main-content-ext-val-copy"
                    v-clipboard:copy="item.value"
                    v-clipboard:success="copySuccess"
                    v-clipboard:error="copyError">
                    复制
                </span>
                <!-- 悬浮展示全部内容 移动端不展示 代码片段不展示-->
                <div v-if="isPc && item.name !== '代码片段链接' && hasOutLen(item.value)"
                    class="f-topic-main-content-ext-val-full">
                    {{item.value}}
                </div>
            </td>
        </tr>
    </table>
</template>

<style lang="less">
    @import '../../../../assets/less/views/topic-content/main-content.less';
</style>

<script>
import {mapState} from 'vuex';
import toast from '@/utils/decorate/toast';

export default {
    computed: {
        ...mapState({
            topicInfo: state => state.topicContent.topicData.topicInfo,
            extMaxStrLen: state => state.topicContent.extMaxStrLen,
            isPc: state => state.common.isPc
        })
    },
    methods: {
        hasOutLen(value) {
            return value.length > this.extMaxStrLen;
        },
        copySuccess() {
            toast.success('复制成功');
        },
        copyError() {
            toast.warn('复制失败');
        }
    }
};
</script>
